import MaydayLogsClient from '@getmayday/mayday-logs-client';
import {
  TokenService,
  MaydayFetchInstance,
} from '@getmayday/mayday-api-instances';
import { useAdminStore } from '@getmayday/vue-modules';
import prepareAxios from './axios';

import { Pinia } from 'pinia';

// const isProduction = process.env.NODE_ENV === 'production';

export const prepareClients = (pinia: Pinia, hostApp: string) => {
  const tokenService = new TokenService(
    () => {
      const adminStore = useAdminStore(pinia);
      return adminStore.accessToken || '';
    },
    () => {
      // TODO
      return '';
    },
    () => {
      return new Promise((resolve) => {
        const configStore = useConfigStore();

        configStore.logout();
        resolve('Logout successful');
      });
    },
  );

  const {
    adminClient,
    authClient,
    knowledgeClient,
    notificationClient,
    brainClient,
    eventClient,
    academyClient,
    assetsProxyClient,
  } = prepareAxios(tokenService, hostApp);

  const logClient = new MaydayLogsClient({
    origin: hostApp,
    lenient: false,
    axiosClient: eventClient as any,
    clientIsConfig: true,
  });

  const fetchClient = new MaydayFetchInstance(
    tokenService,
    `${import.meta.env.VITE_APP_BRAIN_URL}/api`,
  );

  return {
    adminClient,
    authClient,
    knowledgeClient,
    notificationClient,
    brainClient,
    logClient,
    fetchClient,
    academyClient,
    assetsProxyClient,
  };
};
